// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/photo_2024-01-09_11-30-43.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-header {
    background-color: #3285ff;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    color: #fff;
}

.info-header__link {
    color: #fff;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
}

.info-header__link:hover {
    color: #fff;
}

.info-container {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    height: calc(100vh - 50px);
    display: flex;
    justify-content: center;
    align-items: center;
}

.info-content {
    background: rgba(255, 255, 255, 0.7);
    width: 75%;
    padding: 20px;
    border-radius: 10px;
    text-align: start;
    font-size: 20px;
}

.info-content h2 {
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/info.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mDAA+D;IAC/D,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".info-header {\n    background-color: #3285ff;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 40px;\n    color: #fff;\n}\n\n.info-header__link {\n    color: #fff;\n    font-weight: 600;\n    cursor: pointer;\n    text-decoration: none;\n}\n\n.info-header__link:hover {\n    color: #fff;\n}\n\n.info-container {\n    background: url(../assets/images/photo_2024-01-09_11-30-43.jpg);\n    background-size: cover;\n    background-position: center;\n    height: calc(100vh - 50px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.info-content {\n    background: rgba(255, 255, 255, 0.7);\n    width: 75%;\n    padding: 20px;\n    border-radius: 10px;\n    text-align: start;\n    font-size: 20px;\n}\n\n.info-content h2 {\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
